// extracted by mini-css-extract-plugin
export default {"button":"AdznDd","decorated":"RdIVZN","wide":"o9sm5F","inverted":"rzpFxd"};